<template>
  <div>
    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Home tab content -->
      <div style="margin-left:15px;margin-right:15px; margin-bottom:15px;">
        <h3 class="control-sidebar-heading">
          <i class="fa fa-globe"></i>
          {{$ml.get('shared.languageOptions')}}
        </h3>
        <div class="input-group">
          <span class="input-group-addon">
            <img :src="flag" />
            <i v-show="flag == ''" class="fa fa-globe"></i>
          </span>
          <select @change="changeLanguage($event)" class="form-control">
            <option
              v-for="lang in $ml.list"
              :key="lang"
              :value="lang"
              :selected="defaultLanguage == lang"
            >{{lang}}</option>
          </select>
        </div>
        <!--DİL SEÇİMİ VAR-->
        <h3 class="control-sidebar-heading">
          <i class="fa fa-paint-brush"></i>
          {{$ml.get('shared.theme')}}
        </h3>
        <ul class="list-unstyled clearfix">
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-blue"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px; background: #367fa9"
                ></span>
                <span
                  class="bg-light-blue"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222d32"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.blue')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-black"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div style="box-shadow: 0 0 2px rgba(0,0,0,0.1)" class="clearfix">
                <span
                  style="display:block; width: 20%; float: left; height: 7px; background: #fefefe"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 7px; background: #fefefe"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.black')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-purple"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-purple-active"
                ></span>
                <span
                  class="bg-purple"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222d32"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.purple')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-green"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-green-active"
                ></span>
                <span class="bg-green" style="display:block; width: 80%; float: left; height: 7px;"></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222d32"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.green')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-red"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-red-active"
                ></span>
                <span class="bg-red" style="display:block; width: 80%; float: left; height: 7px;"></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222d32"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.red')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-yellow"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-yellow-active"
                ></span>
                <span
                  class="bg-yellow"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #222d32"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p class="text-center no-margin">{{$ml.get('shared.themes.yellow')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-blue-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px; background: #367fa9"
                ></span>
                <span
                  class="bg-light-blue"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.blueLight')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-black-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div style="box-shadow: 0 0 2px rgba(0,0,0,0.1)" class="clearfix">
                <span
                  style="display:block; width: 20%; float: left; height: 7px; background: #fefefe"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 7px; background: #fefefe"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.blackLight')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-purple-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-purple-active"
                ></span>
                <span
                  class="bg-purple"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.purpleLight')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-green-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-green-active"
                ></span>
                <span class="bg-green" style="display:block; width: 80%; float: left; height: 7px;"></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.greenLight')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-red-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-red-active"
                ></span>
                <span class="bg-red" style="display:block; width: 80%; float: left; height: 7px;"></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.redLight')}}</p>
          </li>
          <li style="float:left; width: 33.33333%; padding: 5px;">
            <a
              href="javascript:void(0)"
              data-skin="skin-yellow-light"
              style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)"
              class="clearfix full-opacity-hover"
            >
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 7px;"
                  class="bg-yellow-active"
                ></span>
                <span
                  class="bg-yellow"
                  style="display:block; width: 80%; float: left; height: 7px;"
                ></span>
              </div>
              <div>
                <span
                  style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"
                ></span>
                <span
                  style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"
                ></span>
              </div>
            </a>
            <p
              class="text-center no-margin"
              style="font-size: 12px"
            >{{$ml.get('shared.themes.yellowLight')}}</p>
          </li>
        </ul>
      </div>
      <!-- /.tab-pane -->
    </aside>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultLanguage: "",
      flag: ""
    };
  },
  methods: {
    changeLanguage(event) {
      this.defaultLanguage = event.target.value;
      localStorage.setItem("lang", this.defaultLanguage);
      this.$ml.change(event.target.value);
      if (event.target.value == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
        this.defaultLanguage = "Türkçe";
      }
    }
  },
  created() {
    let language = localStorage.getItem("lang");
    if (language) {
      if (language == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.defaultLanguage = language;
      this.$ml.change(language)
    } else {
      localStorage.setItem("lang", "Türkçe");
      this.defaultLanguage = "Türkçe"
      this.flag = "/src/assets/flags/TR.png";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/shared/Sidebar.vue